import React, { useEffect, useState } from "react";
import "./style/basketTableStyle.scss";
import { BasketItem } from "../../models/BasketItem";
import "../../../style/block.scss";
import "../../../style/feature.scss";
import "./style/basketItemMobile.scss";
import { HiOutlineTicket } from "react-icons/hi";
import { TicketAccess } from "../../models/TicketAccess";
import { MdOutlineCalendarToday } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../store";
import { clearErrors } from "../../store/alerts/alertsActions";
import { useTranslation } from "react-i18next";
import useFacility from "../../../utils/hooks/useFacility";

interface IProps {
  item: BasketItem;
  index: number;
  onRemoveBasket: (index: number) => void;
  handleGetBasket: Function;
  handleAddBasket: (
    assortIds: string,
    price: number,
    ticketAccess: TicketAccess | any,
    validFrom: string | null,
    qnt: number | 1
  ) => void;
}

const BasketListItemMobile: React.FC<IProps> = ({
  item,
  index,
  onRemoveBasket,
  handleAddBasket,
  handleGetBasket,
}: IProps) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(clearErrors());
  }, []);
  const facilityIds = useFacility();
  const { t } = useTranslation();
  const [plusAssort, setPlusAssort] = useState<boolean>(true);
  const [minusAssort, setMinusAssort] = useState<boolean>(true);
  const alertLogin = useSelector((state: State) => state.alerts.errors);
  useEffect(() => {
    if (facilityIds === "1220") {
      if (item.assortName === "OPIEKUN OS. Z NIEPEŁNOSPRAWNOŚCIĄ int.") {
        setPlusAssort(false);
        setMinusAssort(true);
      }
      // setAdditionalAsortName("PRZEWODNIK");
    }
    if (facilityIds === "1220") {
      if (item.assortName === "BILET OPIEKUN GRUPY INT.") {
        setPlusAssort(false);
        setMinusAssort(true);
      }
      // setAdditionalAsortName("PRZEWODNIK");
    }
    if (facilityIds === "1224") {
      if (item.assortName === "PRZEWODNIK") {
        setPlusAssort(false);
        setMinusAssort(false);
      }
      // setAdditionalAsortName("PRZEWODNIK");
    }
    // if (facilityIds === "1214" || facilityIds === "1213" || facilityIds === "1230") {
    //   if (item.assortName === "Opłata internetowa") {
    //     setPlusAssort(false);
    //     setMinusAssort(false);
    //   }
    // }
    if (item.assortName === "Opłata internetowa") {
      setPlusAssort(false);
      setMinusAssort(false);
    }
  
  }, [facilityIds]);



  useEffect(() => {
    if (facilityIds === "1228") {
      if (
        item.assortName === "Opiekun Wystawa" ||
        item.assortName === "Opiekun Pracownie" ||
        item.assortName === "Opiekun Edukator"
      ) {
        setPlusAssort(false);
        setMinusAssort(false);
      }
      if (
        item.assortName === "Asystent Wystawa" ||
        item.assortName === "Asystent Laboratorium" ||
        item.assortName === "Asystent Edukator"
      ) {
        setPlusAssort(false);
      }
    }
  }, [item]);

  return (
    <React.Fragment>
      <div className="basket-list-item-mobile">
        <div className="flex-end-center">
          {minusAssort ? (
            <button onClick={() => onRemoveBasket(index)} className="button small padding-zero button-text-gray">
              {t("usun_z_koszyka")}
            </button>
          ) : (
            <button className="button small padding-zero button-text-gray">{t("usun_z_koszyka")}</button>
          )}
        </div>

        <div className="basket-list-item-mobile-body">
          <div className="basket-list-item-mobile-body-name flex-start-center">
            <HiOutlineTicket className="icon" />
            <b>{item.assortName}</b>
          </div>

          <div className="basket-list-item-mobile-body-line"></div>

          <div className="basket-list-item-mobile-body-limited flex-start-center">
            <MdOutlineCalendarToday className="icon" />
            {item.ticketAccess[0] ? (
              <React.Fragment>
                <span>
                  {t("data")}: {item.ticketAccess[0].startDate}
                </span>
              </React.Fragment>
            ) : (
              <div className="flex-start-center basket-list-valid-from">
                <span>
                  {t("wazny_od")}: {item.validFrom}
                </span>
              </div>
            )}
          </div>

          <div className="basket-list-item-mobile-body-price-line flex-between-center">
            <div className="flex-start-center">
              <strong>
                {item.price * item.qnt} {t("zl")}
              </strong>
              <b>
                ({item.price}
                {t("zl")} / {t("szt")})
              </b>
            </div>

            <div className="qnt flex-center-center">
              {minusAssort ? (
                <button
                  className="flex-center-center qnt-button qnt-opacity"
                  onClick={() => {
                    handleAddBasket(item.assortIds, item.price, item.ticketAccess, null, -1);
                    dispatch(clearErrors());
                    handleGetBasket();
                  }}
                >
                  -
                </button>
              ) : (
                <button className="flex-center-center qnt-button qnt-opacity">-</button>
              )}

              <input disabled className="qnt-input" type="number" value={item.qnt} />
              {plusAssort ? (
                <button
                  className="flex-center-center qnt-button"
                  onClick={() => {
                    handleAddBasket(item.assortIds, item.price, item.ticketAccess, null, 1);
                    handleGetBasket();
                  }}
                >
                  +
                </button>
              ) : (
                <button className="flex-center-center qnt-button">+</button>
              )}
            </div>
          </div>
        </div>
        {alertLogin && alertLogin.length > 0 && <div className="alert alert-red">{alertLogin}</div>}
      </div>
    </React.Fragment>
  );
};

export default BasketListItemMobile;
